import { getDb } from '../db';
import type { CandidatePhrase } from '../../core/types';

/**
 * Repeated multi-word sequences mined from history, waiting for a caregiver to
 * accept them as phrases ("Als Satz speichern?", §5.4). Phase 2 fills this; Phase 1
 * carries it through export/import so nothing mined is lost to a device migration.
 */
export const candidatePhraseRepo = {
  async all(): Promise<CandidatePhrase[]> {
    const db = await getDb();
    return (await db.getAll('candidatePhrases')).sort((a, b) => b.count - a.count);
  },

  async upsert(candidate: CandidatePhrase): Promise<void> {
    const db = await getDb();
    await db.put('candidatePhrases', candidate);
  },

  async remove(text: string): Promise<void> {
    const db = await getDb();
    await db.delete('candidatePhrases', text);
  },

  async bulkPut(rows: readonly CandidatePhrase[]): Promise<void> {
    const db = await getDb();
    const tx = db.transaction('candidatePhrases', 'readwrite');
    await Promise.all(rows.map((row) => tx.store.put(row)));
    await tx.done;
  },
};
